import React from 'react'
import ImageContainer from './ImageContainer'
import ProductData from './ProductData'
import { ParallaxProvider } from 'react-scroll-parallax'


const MainProductDataShow = () => {
    return (
        <ParallaxProvider>
            <div className='grid grid-cols-1 md:grid-cols-2'>
                <ImageContainer />
                <ProductData />
            </div>
        </ParallaxProvider>
    )
}

export default MainProductDataShow
